(function ($, SCS, debug) {
	"use strict";
	// jshint camelcase: false

	var getPagePath = require('lib/util/datalayer').getPagePath;

	/**
	 * The page object according to the specifications
	 * @returns {Page}
	 * @constructor
	 */
	var Page = function () {
		$.extend(this, {
			init: function (path, language, cfu, viewtype, template) {
				SCS.portal.datalayer.originalPagePath = this.path = path || "";
				this.language = language || "";
				this.cfu = cfu || "";
				this.charset = "utf-8";
				this.viewtype = viewtype || "";
				this.template = template || "";
				this.pagetype = ""; // intentionally left empty
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The platform object according to the specifications
	 * @returns {Platform}
	 * @constructor
	 */
	var Platform = function () {
		$.extend(this, {
			init: function (platform, environment) {
				this.platform = platform || "";
				this.environment = environment || "";
				this.context = "online";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Product}
	 * @constructor
	 */
	var Product = function () {
		$.extend(this, {
			init: function (id, key, name) {
				this.id = id || "";
				this.key = key || "";
				this.name = name || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Category}
	 * @constructor
	 */
	var Category = function () {
		$.extend(this, {
			init: function (name, value) {
				this.name = name || "";
				this.value = value || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Adds a product category to the currently(!) viewed product's Category list
	 */
	Product.prototype.withCategory = function (key, value) {
		if (key && value) {
			this.productCategory_list = this.productCategory_list || [];
			this.productCategory_list.push(new Category(key, value));
		}
		return this;
	};

	/**
	 * The Conversion object according to the specifications
	 * @see https://wiki.swisscom.com/pages/viewpage.action?spaceKey=TAG&title=Online+Data+Layer+Platform+Integration#OnlineDataLayerPlatformIntegration-Conversion
	 * @returns {Conversion}
	 * @constructor
	 */
	var Conversion = function () {
		$.extend(this, {
			init: function (category, detail, _class) {
				this.category = category || "";
				this.detail = detail || "";
				this['class'] = _class;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Event}
	 * @constructor
	 */
	var Event = function () {
		$.extend(this, {
			init: function (action, label, location, category, linkName) {
				this.action = action || "";
				this.label = label || "";
				this.location = location || "";
				this.category = category || "";
				if (linkName) {
					this.linkName = linkName;
				}
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Interaction}
	 * @constructor
	 */
	var Interaction = function () {
		$.extend(this, {
			init: function () {
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Set event information. Either conversion information OR event information can be set
	 * @param action
	 * @param label
	 * @param location
	 * @param category
	 * @param linkName
	 * @returns {Interaction}
	 */
	Interaction.prototype.withEvent = function (action, label, location, category, linkName) {
		this.event = new Event(action, label, location, category, linkName);
		return this;
	};

	/**
	 * Set conversion information. Either conversion information OR event information can be set
	 * @param conversionCategory
	 * @param conversionDetail
	 * @param conversionClass
	 * @returns {Interaction}
	 */
	Interaction.prototype.withConversion = function (conversionCategory, conversionDetail, conversionClass) {
		if (conversionCategory && conversionDetail) {
			this.conversion = new Conversion(conversionCategory, conversionDetail, conversionClass || "");
		} else {
			debug.log("SCS.portal.datalayer.js > withConversion > conversionCategory and Detail are mandatory in Conversion objects");
		}
		return this;
	};

	/**
	 *
	 * @param rawdata
	 * @returns {Interaction}
	 * Make sure event is set before calling this
	 */
	Interaction.prototype.withRawData = function (rawdata) {
		if (typeof this.event !== "undefined") {
			this.event.rawdata = rawdata;
		}
		return this;
	};

	Interaction.prototype.withProfile = function (profile) {
		this.profile = profile;
		return this;
	};

	Interaction.prototype.withProduct = function (product) {
		this.product = product;
		return this;
	};

	/**
	 * Fires the click Interaction. The action/label/location/category must always be set, even for the conversion tracking
	 */
	Interaction.prototype.track = function () {
		if (!SCS.datalayer || !SCS.datalayer.track) {
			debug.log("Cannot track event, SCS Datalayer not available at this time. Please check whether utag.sync.js has been loaded");
			return;
		}

		if (this.event && this.conversion) {
			debug.log("SCS.portal.datalayer.js > track > Warning: event and conversion set at the same time!");
		}

		// in order to not permanently add the event and avoid side effects on multiple
		// user interactions, we clone the existing trackObj to not modify it
		var dataObj = $.extend(true, {}, SCS.portal.datalayer.trackObj);

		// transfer all set props in data object
		for (var prop in this) {
			if (this.hasOwnProperty(prop) && typeof this[prop] !== "function") {
				dataObj[prop] = this[prop];
			}
		}

		// delegating tracking call to Tealium
		debug.log('SCS.portal.datalayer.js > Interaction > track', dataObj);
		SCS.datalayer.track(dataObj);
	};

	/**
	 * User information (currently only login status)
	 * @returns {Profile}
	 * @constructor
	 */
	var Profile = function (user) {
		$.extend(this, {
			init: function () {
				this.loggedIn = user ? "login" : "";
				if (user.getSegment()) {
					this.cfu = user.getSegment();
				}
			}
		});

		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Cart}
	 * @constructor
	 */
	var Cart = function () {
		$.extend(this, {
			init: function (ordertotal) {
				this.ordertotal = new Number(parseFloat(ordertotal)).valueOf() || 0.0;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};



	/**
	 * Namespace for Tealium related functionality
	 */
	SCS.portal = SCS.portal || {};
	SCS.portal.datalayer = {

		// This ist the basic data to be sent to Tealium. Will be enriched with various sub-objects, e.g. page and platform which are mandatory.
		// Whenever there is event tracking, e.g. click tracking using the Interaction.track function this data will be cloned as template
		trackObj: {},

		// flag indicating whether the page should track automatically or an explicit SCS.portal.datalayer.trackPageView has to be called.
		// e.g. true on product detail pages that first need to load product data from the ecommerce backend
		// may become obsolete with the new Hybris implementation
		isDeferred: false,

		//Set as soon as the initialize method has been called
		initialized: false,

		// stores the original trackObj.page.path value before it's extended e.g. used for click tracking tabs when the current tab
		// name shall be appended to page path
		originalPagePath: "",

		// used together with aforementioned originalPagePath for temporarily adding new page.path elements
		appendedPagePaths: [],

		/**
		 * Initialization function
		 *
		 * Depending on the 'deferred' parameter tracking data object is instantiated in the datalayer.
		 * If the page shall manage its own page view tracking, call the function with 'deferred' set to true
		 * but be aware that you will need to fire SCS.portal.datalayer.trackPageView when the page is ready loaded.
		 * A sample use case for this behavior are e.g. the product detail pages with the datahub where further product
		 * information needs assembled first before explicitly firing the tracking call
		 */
		initializeTrackingData: function (path, lang, cfu, viewtype, template, platform, environment, deferred) {
			var mod = this;
			debug.log("SCS.portal.datalayer.initializeTrackingData", arguments);
			this.isDeferred = deferred;
			this.initialized = true;

			// initialize mandatory page and platform data
			this.trackObj = {
				page: new Page(path, lang, cfu, viewtype, template),
				platform: new Platform(platform, environment)
			};

			require('lib/personalization/profile').getProfile().then(function(profile) {
				var user = profile.getUser();
				if(user) {
					mod.trackObj.profile = new Profile(user);
				}
			});
		},

		/**
		 * Check if the user is logged in
		 * @returns {string} "" or "login"
		 * @deprecated use lib/personalization/profile.ts
		 */
		isLoggedIn: function () {
			return (this.trackObj.profile && this.trackObj.profile.loggedIn) || "";
		},

		/**
		 * Set the optional page type
		 * @param pageType value from the pageType dropdown in page properties
		 */
		setPageType: function (pageType) {
			if (pageType) {
				this.trackObj.page.type = pageType;
			}
		},

		/**
		 * Sets the product in the tracking object. This contains the initially viewed product when opening the page
		 */
		setProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			this.trackObj.product = this.createProduct(id, key, name, CategoryMaster, Category2, productBrand);
		},

		/**
		 * ODL Getter for the current product
		 * @return {SCS.}
		 */
		getProduct: function () {
			return this.trackObj.product || {};
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		getTemplate: function () {
			return this.trackObj.page.template || '';
		},

		/**
		 * Sets the conversion information in the tracking object.
		 */
		setConversion: function (category, detail, _class) {
			this.trackObj.conversion = new Conversion(category, detail, _class);
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		setCart: function (ordertotal) {
			this.trackObj.cart = new Cart(ordertotal);
		},

		/**
		 * Sets a custom UDO parameter in the datalayer
		 * @param name
		 * @param value
		 */
		addUdoProperty: function (name, value) {
			this.trackObj.udo = this.trackObj.udo || {};
			this.trackObj.udo[name] = value;
		},

		/**
		 * Creates a Product
		 */
		createProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			return new Product(id, key, name)
				.withCategory("ProductCategoryMaster", CategoryMaster)
				.withCategory("ProductCategory2", Category2)
				.withCategory("Brand", productBrand);
		},

		/**
		 * Empties the current product_list
		 */
		resetProductList: function () {
			this.trackObj.product_list = [];
		},

		/**
		 * Adds an InOne product to the product_list.
		 * @param siebelName aka siebelId when it is actually the siebelName we're working with since the siebelId is environment dependent, like a primary database key
		 * @param {String} price the price
		 * @param {String} type can be either "bundle" or "flavour"
		 */
		addInOneProduct: function (siebelName, price, type) {
			if (!siebelName || !type || !/^(bundle|flavour)$/.test(type)) {
				debug.log("SCS.portal.datalayer.js > addInOneProduct > invalid type", type);
			} else {
				this.trackObj.product_list = this.trackObj.product_list || [];
				var product = new Product(siebelName, siebelName).withCategory("inOne", type);
				product.quantity = 1;
				product.priceRecurring = price || 0;
				this.trackObj.product_list.push(product);
			}
		},

		/**
		 * Queues a page view event to track a page view.
		 * Note that there will be an automatic implicit call on page load
		 */
		trackPageView: function () {
			var mod = this;
			// Wait until profile is available
			require('lib/personalization/profile').getProfile().then(function(profile) {
				if (window.SCS && window.SCS.datalayer && window.SCS.datalayer.page) {
					// delegate tracking call to Tealium
					SCS.datalayer.page(mod.trackObj, mod.isDeferred);
				} else {
					debug.log('SCS.datalayer.page not available, utag.sync.js not loaded?');
				}
			});
		},

		/**
		 * Fires a standard click Interaction with the default parameter set.
		 * If you wish to add more information like product or profile information,
		 * create a new Interaction and use the appropriate chaining methods, e.g.
		 * .withRawData(...) in combination with .track() to send the event manually.
		 * @param action the event action
		 * @param label the event label
		 * @param location the event location
		 * @param category the event category
		 * @param linkName the friendly name of the event/link (appears in SiteCatalyst link tracking reports)
		 */
		trackEvent: function (action, label, location, category, linkName) {
			if (action && label && location && category) {
				var interaction = new Interaction()
					.withEvent(action, label, location, category, linkName);
				interaction.track();
			}
		},

		/**
		 * Track a user conversion
		 * @param conversionCategory
		 * @param conversionDetail
		 * @param conversionClass
		 */
		trackConversion: function (conversionCategory, conversionDetail, conversionClass) {
			if (conversionCategory && conversionDetail) {
				var interaction = new Interaction()
					.withConversion(conversionCategory, conversionDetail, conversionClass);
				interaction.track();
			}
		},

		/**
		 * Appends an override to the current page page
		 * @param {string} value new path part to push on the stack
		 * @param {boolean} [popPreviousValue] whether to first remove the previous value on the stack. Defaults to false
		 * @param {boolean} [resetCompletely] whether to remove all items from the stack first. Defaults to false
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		pushPagePath: function (value, popPreviousValue, resetCompletely, separator) {

			// Check whether the previously added stack value is the same and if so abort. This may happen every once in a
			// while if components fire multiple times.
			if (this.appendedPagePaths.length > 0 && this.appendedPagePaths[this.appendedPagePaths.length - 1] === getPagePath(value)) {
				return false;
			}

			// Remove previous stack value
			if (popPreviousValue) {
				this.popPagePath();
			}

			// Remove all previous values from the stack
			if (resetCompletely) {
				this.appendedPagePaths = [];
			}

			this.appendedPagePaths.push(getPagePath(value));
			this.applyPagePath(separator);
			debug.log("SCS.portal.datalayer.js > pushPagePath > path is now ", this.trackObj.page.path);
			return true;
		},

		/**
		 * Removes an override from the current page path (last in, last out)
		 */
		popPagePath: function () {
			this.appendedPagePaths.pop();
			this.applyPagePath();
			debug.log("SCS.portal.datalayer.js > popPagePath > path is now ", this.trackObj.page.path);
		},

		/**
		 * Applys the page path overrides. This should not be called directly, but always using
		 * implicitly by calling pushPagePath and popPagePath
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		applyPagePath: function (separator) {
			separator = separator || '/';
			this.trackObj.page.path = this.originalPagePath;
			if (this.appendedPagePaths.length > 0) {
				this.trackObj.page.path += separator + this.appendedPagePaths.join(separator);
			}
		},

		/**
		 * Enable UX tracking (e.g. Clicktale) on Tealium side
		 * @param {boolean} value
		 */
		setUxTracking: function (value) {
			this.trackObj.apps = this.trackObj.apps || {};
			this.trackObj.apps.uxTracking = this.trackObj.apps.uxTracking || {};
			this.trackObj.apps.uxTracking.active = value;
		}

	};

	// export library classes
	SCS.portal.datalayer.Interaction = Interaction;

})(window.$, window.SCS = window.SCS || {}, window.debug);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tracking/SCS.portal.datalayer.js
// module id = 333
// module chunks = 0